import React, { useEffect, useState } from 'react'
import apiClient from '../../services/api'

const quickLinks = [
  { href: '/admin/appointments', label: 'Appointments', meta: 'Review requests and update booking status.' },
  { href: '/admin/services', label: 'Services', meta: 'Manage clinic offerings, pricing, and availability.' },
  { href: '/admin/gallery', label: 'Gallery', meta: 'Refresh visual content shown on the public site.' },
  { href: '/admin/doctors', label: 'Doctors', meta: 'Update specialist profiles and homepage highlights.' },
  { href: '/admin/testimonials', label: 'Testimonials', meta: 'Manage patient feedback shown across the site.' },
  { href: '/admin/faqs', label: 'FAQ', meta: 'Edit common questions and answers for visitors.' },
  { href: '/admin/subscribers', label: 'Subscribers', meta: 'Review newsletter signups and audience growth.' },
  { href: '/admin/contact-messages', label: 'Messages', meta: 'Reply to patient enquiries and track follow-up.' },
  { href: '/admin/blog', label: 'Blog', meta: 'Publish updates, articles, and clinic announcements.' },
  { href: '/admin/settings', label: 'Settings', meta: 'Update clinic branding, contact details, and site info.' }
]

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    total: 0,
    pending: 0,
    confirmed: 0,
    services: 0,
    subscribers: 0,
    contactMessages: 0,
    unrepliedMessages: 0
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { data } = await apiClient.get('/api/appointments')
        const total = data.length
        const pending = data.filter((item) => item.status === 'pending').length
        const confirmed = data.filter((item) => item.status === 'confirmed').length
        const servicesRes = await apiClient.get('/api/services')
        const services = servicesRes.data.length
        const subscribersRes = await apiClient.get('/api/cms/subscribers')
        const subscribers = subscribersRes.data.length
        const contactRes = await apiClient.get('/api/cms/contact-messages')
        const contactMessages = contactRes.data.length
        const unrepliedMessages = contactRes.data.filter((message) => message.status !== 'replied').length
        setStats({ total, pending, confirmed, services, subscribers, contactMessages, unrepliedMessages })
      } catch (error) {
        console.error('Error fetching dashboard stats', error)
      } finally {
        setLoading(false)
      }
    }

    fetchStats()
  }, [])

  if (loading) return <div>Loading dashboard...</div>

  return (
    <div className="admin-dashboard-page">
      <div className="admin-page-header">
        <div>
          <h2>Admin Dashboard</h2>
          <p>
            This dashboard now works more like a control center. It highlights operational totals first, then gives you clearer paths into the most important admin workflows.
          </p>
        </div>
      </div>

      <div className="admin-quick-links">
        {quickLinks.map((link) => (
          <a key={link.href} className="admin-quick-link" href={link.href}>
            <span className="admin-quick-link-label">{link.label}</span>
            <span className="admin-quick-link-meta">{link.meta}</span>
          </a>
        ))}
      </div>

      <div className="row gy-3">
        <div className="col-md-4">
          <div className="card shadow-sm p-3 admin-stat-card">
            <h4>Total Appointments</h4>
            <p className="display-6">{stats.total}</p>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow-sm p-3 admin-stat-card">
            <h4>Pending Appointments</h4>
            <span className="admin-status-badge admin-status-pending mb-3">Needs Review</span>
            <p className="display-6">{stats.pending}</p>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow-sm p-3 admin-stat-card">
            <h4>Confirmed</h4>
            <span className="admin-status-badge admin-status-confirmed mb-3">Approved</span>
            <p className="display-6">{stats.confirmed}</p>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow-sm p-3 admin-stat-card">
            <h4>Total Services</h4>
            <p className="display-6">{stats.services}</p>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow-sm p-3 admin-stat-card">
            <h4>Subscribers</h4>
            <p className="display-6">{stats.subscribers}</p>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow-sm p-3 admin-stat-card">
            <h4>Contact Messages</h4>
            <p className="display-6">{stats.contactMessages}</p>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card shadow-sm p-3 admin-stat-card">
            <h4>Awaiting Reply</h4>
            <span className="admin-status-badge admin-status-new mb-3">Follow Up</span>
            <p className="display-6">{stats.unrepliedMessages}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminDashboard
